// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalLoading_container__0nt0Y","message":"ModalLoading_message__mfciP","title":"ModalLoading_title__tYLAT"};